@if (isVisible) {
  <div
    class="main-loading-container default"
    [style.zIndex]="zIndex"
    [ngClass]="{ 'transparent-background': backgroundColor === 'transparent', light: backgroundColor === 'light' }"
    [style]="{ '--size': size }">
    <div class="loader revert">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
}
